import { Box, CardMedia, SxProps, Theme } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';

import { DRAWER_IMAGE_HEIGHT_DESKTOP } from '../../../constants/ui';
import { ThumbnailRail } from './ThumbnailRail';

interface IProps {
  images: string[];
  alt?: string;
  height?: number;
  activeImage?: string | null;
}

const columnSx: SxProps<Theme> = { display: 'flex', flexDirection: 'column', gap: 2 };

const frameSx: SxProps<Theme> = { backgroundColor: 'common.white', borderRadius: 0.5 };

export const ImageGallery: React.FC<IProps> = ({
  images,
  alt = '',
  height = DRAWER_IMAGE_HEIGHT_DESKTOP,
  activeImage,
}) => {
  const [pickedImage, setPickedImage] = useState<string | null>(null);

  useEffect(() => {
    setPickedImage(activeImage ?? null);
  }, [activeImage]);

  const displayedImage = pickedImage ?? images[0];

  const mainImageSx: SxProps<Theme> = useMemo(() => ({ width: '100%', height, objectFit: 'contain' }), [height]);

  if (!displayedImage) {
    return null;
  }

  return (
    <Box sx={columnSx}>
      <Box sx={frameSx}>
        <CardMedia component="img" image={displayedImage} alt={alt} sx={mainImageSx} />
      </Box>
      <ThumbnailRail images={images} activeImage={displayedImage} alt={alt} onPick={setPickedImage} />
    </Box>
  );
};
